import { drop } from "lodash-es";

export function paginateItems<T>(items: T[], page: number, pageSize: number) {
  const _page = page || 1;
  const _pageSize = pageSize || 10;
  const offset = (_page - 1) * _pageSize;
  const pagedItems = drop(items, offset).slice(0, _pageSize);

  return {
    page: _page,
    pageSize: _pageSize,
    total: items.length,
    pages: Math.ceil(items.length / _pageSize),
    pagedItems,
  };
}
